module.exports = __webpack_public_path__ + "static/media/merenda.696552aa.png";